"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobOffersContract = void 0;
/* eslint-disable perfectionist/sort-objects */
const core_1 = require("@ts-rest/core");
const schemas_1 = require("../../../../schemas");
const messages_1 = require("./messages");
const offers_request_1 = require("./offers.request");
const offers_response_1 = require("./offers.response");
const c = (0, core_1.initContract)();
exports.JobOffersContract = c.router({
    create: {
        method: 'POST',
        path: '/',
        body: offers_request_1.OfferCreateRequestSchema,
        responses: { 201: schemas_1.BaseResponseSchema },
    },
    update: {
        method: 'PATCH',
        path: '/:offerId',
        body: offers_request_1.OfferUpdateRequestSchema,
        responses: { 200: schemas_1.BaseResponseSchema },
        pathParams: offers_request_1.OfferIdPathParamsSchema,
    },
    delete: {
        method: 'DELETE',
        path: '/:offerId',
        responses: { 200: schemas_1.BaseResponseSchema },
        pathParams: offers_request_1.OfferIdPathParamsSchema,
    },
    findById: {
        method: 'GET',
        path: '/:offerId',
        responses: { 200: offers_response_1.OfferDetailSchema },
        pathParams: offers_request_1.OfferIdPathParamsSchema,
    },
    search: {
        method: 'GET',
        path: '/',
        query: offers_request_1.OfferSearchQuerySchema,
        responses: { 200: offers_response_1.OfferSearchResponseSchema },
    },
    messages: messages_1.JobOfferMessagesContract,
}, { pathPrefix: '/offers' });
